module.exports = __webpack_public_path__ + "img/crate-empty.ff68bea5.svg";